import { Link } from "react-router-dom";

export default function HomePage(props) {

    return (
        <>
            <div className="container col-xxl-8 px-4 py-5">
                <div className="p-5 mb-4 bg-light rounded-3">
                    <div className="container-fluid py-5 text-center">
                        <h1 className="display-5 fw-bold">Заметки Menote</h1>
                        <div className="fs-4">
                        <p>Удобный сервис для создания заметок на все случаи жизни.</p>
                        <p>(в активной разработке)</p>
                        <p className="text-center">
                            <Link to="/login">Войти</Link> | <Link to="/register">Зарегистрироваться</Link>
                        </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="page-home container features">
                <div className="row">
                    <div className="col-lg-4 text-center">
                        <div className="icon-holder">
                            <i className="c-blue-500 ti-write"></i>
                        </div>
                       
                        <h2>Редактор текста</h2>
                        <p>Простой, но функциональный редактор форматированного текста для создания ваших уникальных заметок.</p>
                        {/* <p><a className="btn btn-secondary" href="#">View details »</a></p> */}
                    </div>
                    <div className="col-lg-4 text-center">
                        <div className="icon-holder">
                            <i className="c-blue-500 ti-bookmark-alt"></i>
                        </div>
                        <h2>Метки и Разделы</h2>
                        <p>Создавайте свои собственные разделы и метки для упорядочивания и большей детализации в ваших заметок.</p>
                        {/* <p><a className="btn btn-secondary" href="#">View details »</a></p> */}
                    </div>
                    <div className="col-lg-4 text-center">
                        <div className="icon-holder">
                            <i className="c-blue-500 ti-files"></i>
                        </div>
                        <h2>Документы</h2>
                        <p>Прикрепляйте документы к заметкам что бы хранить всё в одном месте.</p>
                        {/* <p><a className="btn btn-secondary" href="#">View details »</a></p> */}
                    </div>
                </div>
            </div>

        </>
    )
}